import type { ComponentPropsWithoutRef } from "react";
import { twMerge } from "@/lib/twMerge";

/** The bordered surface every page section, tile, and detail pane sits on — the 8px card
 * radius, deliberately rounder than the 4px buttons and inputs (see frontend/README.md). */
export function Card({ className, ...props }: ComponentPropsWithoutRef<"div">) {
  return <div className={twMerge("rounded-lg border border-line bg-surface p-5", className)} {...props} />;
}
